"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var MergeCartModalDesktop_1 = __importDefault(require("./MergeCartModalDesktop"));

var MergeCartModalMobile_1 = __importDefault(require("./MergeCartModalMobile"));

var frontend_application_1 = require("@ryerson/frontend.application");

var MergeCartModalContent_1 = require("./MergeCartModalContent");

var MergeCartModal = function MergeCartModal(_ref) {
  var showMergeCartModal = _ref.showMergeCartModal,
      setShowMergeCartModal = _ref.setShowMergeCartModal,
      numberOfItems = _ref.numberOfItems;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      language = _ref2.localization.language;

  var content = MergeCartModalContent_1.MergeCartContent[language] || MergeCartModalContent_1.MergeCartContent.en;
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsx)(MergeCartModalMobile_1.default, {
        content: content,
        showMergeCartModal: showMergeCartModal,
        setShowMergeCartModal: setShowMergeCartModal,
        numberOfItems: numberOfItems
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsx)(MergeCartModalDesktop_1.default, {
        content: content,
        showMergeCartModal: showMergeCartModal,
        setShowMergeCartModal: setShowMergeCartModal,
        numberOfItems: numberOfItems
      })
    })]
  });
};

exports.default = MergeCartModal;